// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fy9gb95tbnUjbxTZ {
  border-radius: 8px;
  background: #fff;
  width: 100%;
  margin-top: 20px;
  box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./app/assets/pages/newComplaintDetail/ComplaintCard/index.modules.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;AACF","sourcesContent":[".ComplaintCard{\n  border-radius: 8px;\n  background: #fff;\n  width: 100%;\n  margin-top:20px;\n  box-sizing: border-box;\n  \n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ComplaintCard": `fy9gb95tbnUjbxTZ`
};
export default ___CSS_LOADER_EXPORT___;
